import Modal from "../../../../../shared/components/UI/Modal/Modal";
import { Dispatch, useState, SetStateAction, useEffect } from "react";
import "./CreatingCamouflageModal.scss"
import MergedImages from "../../../../../shared/components/other/mergeImages/MergedImages";
import { displayCloseModalDialog } from "../../../../../shared/services/Notifications/NotificationServices";
import useDefaultCamouflages from "./Hooks/useDefaultCamouflages";
import Image from "../../Image/Image";
import useUserCreateCamouflage from "./Hooks/useUserCreateCamouflage";
import { Camouflage, CamouflageOwnerType } from "../types/camouflageTypes";

interface CreatingCamouflageModalProps {
    isOpen: boolean,
    setIsOpen: Dispatch<SetStateAction<boolean>>,
    type: CamouflageOwnerType,
    slug: string | null | undefined
}

//!!!ВАЖНО идея типизации компонента заключается в том, чтобы сделать его более универсальным. 
// Можно написать отдельные хуки для получения данных для камуфляжей команды и сделать логику их использования здесь 
// в зависимости от указанного типа 

//еще не менее важный момент: когда много камуфляжей, нижние элементы модалки едут вниз, надо это пофиксить
export default function CreatingCamouflageModal({
    isOpen,
    setIsOpen,
    type,
    slug
}:
    CreatingCamouflageModalProps
) {
    const { data, isLoading, error } = useDefaultCamouflages()
    // const {mutate} = type === 'profile' ? useProfileCreateCamouflage() : *хук для команды?*
    const { mutate } = useUserCreateCamouflage(type, slug) //изменить позже, как надо будет привязать к команде

    const [searchElem, setSearchElem] = useState('')
    const [isFocused, setIsFocused] = useState(false)
    const [selectedItems, setSelectedItems] = useState<Camouflage[]>([])
    const [isDefaultName, setIsDefaultName] = useState('Новый камуфляж')
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 913)

    const reset = () => {
        setSelectedItems([])
        setIsDefaultName('Новый камуфляж')
    }

    const closeModal = () => {
        if (selectedItems.length === 0) {
            setIsOpen(false)
        } else {
            displayCloseModalDialog(() => {
                setIsOpen(false)
                reset()
            })
        }
    }

    const toggleItem = (item: Camouflage) => {
        setSelectedItems(prev => {
            const isSelected = prev.some(i => i.name === item.name)

            if (isSelected) {
                return prev.filter(i => i.name !== item.name)
            }

            if (prev.length < 4) {
                return [...prev, item]
            }

            return prev
        })
    }

    const filtredCamouflage = data?.filter((camouflage: Camouflage) =>
        `${camouflage.name}`.toLowerCase().includes(searchElem.toLowerCase())
    )

    useEffect(() => {
        if (selectedItems.length === 0) {
            setIsDefaultName("Новый камуфляж");
        } else if (selectedItems.length === 1) {
            setIsDefaultName(selectedItems[0].name);
        } else {
            setIsDefaultName("Комбинированный");
        }
    }, [selectedItems]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 913)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const camouflageList =
        <div className='creatingCamouflageModal__left-camouflageList'>
            {filtredCamouflage?.length === 0 ? (
                <div className="creatingCamouflageModal__left-camouflageList-empty">
                    <svg width="66" height="71" viewBox="0 0 66 71" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.81912 68.4175C5.81706 71.1131 9.6218 71.6785 12.3172 69.6803C18.2171 65.3079 25.3378 62.775 32.9996 62.775C40.6614 62.775 47.7821 65.3079 53.6821 69.6803C56.3778 71.6785 60.1824 71.1131 62.1799 68.4175C64.1781 65.7218 63.6128 61.9172 60.9171 59.9198C53.0406 54.0813 43.4081 50.625 32.9996 50.625C22.5911 50.625 12.9586 54.0813 5.08206 59.9198C2.38663 61.9172 1.82125 65.7218 3.81912 68.4175Z"
                            fill="#2A2D31" />
                        <path d="M65.3996 12.15C65.3996 18.86 61.7732 24.3 57.2996 24.3C52.826 24.3 49.1996 18.86 49.1996 12.15C49.1996 5.43972 52.826 0 57.2996 0C61.7732 0 65.3996 5.43972 65.3996 12.15Z"
                            fill="#2A2D31" />
                        <path d="M8.69961 24.3C13.1731 24.3 16.7996 18.86 16.7996 12.15C16.7996 5.43972 13.1731 0 8.69961 0C4.22614 0 0.599609 5.43972 0.599609 12.15C0.599609 18.86 4.22614 24.3 8.69961 24.3Z"
                            fill="#2A2D31" />
                    </svg>
                    <p>Камуфляж не найден</p>
                </div>
            ) : (
                filtredCamouflage?.map((camouflage: Camouflage, index: number) => (
                    <div
                        key={camouflage.id ?? index}
                        onClick={() => toggleItem(camouflage)}
                        className={`creatingCamouflageModal__left-camouflageList-item ${selectedItems.some(i => i.name === camouflage.name) ? 'selected' : ''}`}
                    >
                        <Image sizes="100px" src={camouflage.img || '/no_photo.svg'} resolution="camouflage" />
                        <p>{camouflage.name}</p>
                    </div>
                )
                ))}
        </div>

    const preview =
        <>
            <MergedImages
                srcs={selectedItems.length != 0 ? selectedItems.map(c => c.img) : ['/no_photo.svg']}
                radius={90}
                className="creatingCamouflageModal__right-multiCamouflage"
            />
            <h2>{isDefaultName}</h2>
            <div className="creatingCamouflageModal__right-compound">
                <h2>Состав:</h2>
                <p>{selectedItems.map(item => item.name).join(', ')}</p>
            </div>
        </>

    return (
        <Modal
            isOpen={isOpen}
            closeModal={() => closeModal()}
            classes={{
                modal: 'creatingCamouflageModal',
                closeButton: 'universaleditmodal_closeButton'
            }}
        >
            <div className="creatingCamouflageModal__left">
                <div className="creatingCamouflageModal__left-title">
                    <h1>Камуфляжи</h1>
                    <p>Выбор нескольких вариантов создает комбинированный камуфляж</p>
                </div>
                <div className="creatingCamouflageModal__left-search-wrapper">
                    <input type='search'
                        className="creatingCamouflageModal__left-search"
                        value={searchElem}
                        placeholder="Поиск"
                        onInput={({ target }) => setSearchElem((target as HTMLInputElement).value)}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                    />
                    {searchElem.length === 0 && (
                        <svg width="30" height="22" viewBox="0 0 30 22" fill="none" xmlns="http://www.w3.org/2000/svg" className="creatingCamouflageModal__left-search-icon">
                            <rect width="1" height="22" fill="#28282C" />
                            <g transform="translate(-5, -5) scale(1.5)">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M14 7C12.3431 7 11 8.34315 11 10C11 11.6569 12.3431 13 14 13C14.8273 13 15.5764 12.6651 16.1191 12.1235C16.1206 12.122 16.122 12.1206 16.1235 12.1191C16.1246 12.118 16.1257 12.1169 16.1268 12.1158C16.6665 11.5733 17 10.8256 17 10C17 8.34315 15.6569 7 14 7ZM17.1614 12.4509C17.6871 11.7738 18 10.9235 18 10C18 7.79086 16.2091 6 14 6C11.7909 6 10 7.79086 10 10C10 12.2091 11.7909 14 14 14C14.9252 14 15.7771 13.6859 16.4548 13.1584L19.1462 15.8533C19.3414 16.0487 19.6579 16.0489 19.8533 15.8538C20.0487 15.6586 20.0489 15.3421 19.8538 15.1467L17.1614 12.4509Z"
                                    fill="#E5E4DF"
                                />
                            </g>
                        </svg>
                    )}
                    {!!(searchElem.length > 0) && (
                        <button
                            type="button"
                            className="creatingCamouflageModal__left-search-close"
                            onClick={() => { setSearchElem('') }}
                        >
                            <img src='/UI/closeIconBlack.svg' />
                        </button>
                    )}
                </div>
                <div className="creatingCamouflageModal__left-camouflageList-item-gradient" />
                {isMobile ? preview : camouflageList}
            </div>
            <div className="creatingCamouflageModal__right">
                {isMobile ? camouflageList : preview}
                <button
                    type='button'
                    className={`creatingCamouflageModal__right-addButton ${selectedItems.length == 0 ? 'disabled' : ''}`}
                    disabled={selectedItems.length == 0}
                    onClick={() => {
                        mutate(selectedItems.map(item => item.id))
                        setIsOpen(false)
                        reset()
                    }}
                >
                    Добавить
                </button>
            </div>
        </Modal >
    )
}